import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from '@/react-query/api';

import { usePreferences } from '../usePreferences';

export interface PromptOption {
  name: string;
  ui_label: string;
}

export const usePrompts = () => {
  // prompts are gated by a feature flag
  const { data: preferences } = usePreferences();
  const isVideaNotesEnabled = preferences?.isVideaNotesEnabled;

  const {
    primaryPracticeId: currentPracticeId,
    primaryOrganizationId: currentOrganizationId,
  } = useSelector((state: any) => state.login.user);

  return useQuery({
    queryKey: ['videa-notes-prompts', currentPracticeId, currentOrganizationId],
    queryFn: async () => {
      return makeAPIRequestReactQuery<Array<PromptOption>>(
        '/videa-notes/prompts',
        {},
        'get',
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            practice: currentPracticeId,
            org: currentOrganizationId,
          },
        },
      );
    },
    enabled:
      currentPracticeId !== undefined &&
      currentOrganizationId !== undefined &&
      isVideaNotesEnabled === true,
  });
};
